<div class="flex flex-col w-full h-full">
  <label
    class="text-ts-input-label-size text-ts-input-label font-ts-input-label-weight leading-ts-input-label"
    *ngIf="label"
    >{{ label }}</label
  >

  <div class="ts-datepicker">
    <input
      #inputElement
      tsDateMask
      class="w-full"
      [min]="min"
      [max]="max"
      type="text"
      [placeholder]="placeholder || 'MM/DD/YYYY'"
      [attr.data-testid]="testId"
      [formControl]="control"
      [matDatepicker]="picker"
      (dateChange)="dateChange.emit()"
      (blur)="blur.emit()"
    />
    <mat-datepicker-toggle
      [ngStyle]="{ transform: 'translateY(1px)' }"
      matDatepickerToggleIcon="caret"
      matSuffix
      disableRipple="true"
      [for]="picker"
    >
      <mat-icon class="text-gray-400" matDatepickerToggleIcon>calendar_month</mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker
      [startView]="mode"
      yPosition="below"
      #picker
      (monthSelected)="setMonthAndYear($event, picker)"
    ></mat-datepicker>
  </div>

  <p class="text-xs text-gray-500 mt-1" *ngIf="hint">{{ hint }}</p>

  <div *ngIf="control?.errors && errorMessages">
    <ng-container *ngFor="let error of control?.errors | keyvalue">
      <p class="mb-1 text-xs text-danger" *ngIf="errorMessages[error.key]?.length > 0">
        {{ errorMessages[error.key] }}
      </p>
    </ng-container>
  </div>
</div>
